import { GenericImageSettings } from "@/api/user-settings";
import { cn } from "@/lib/utils";

interface GenericImagePreviewProps {
  settings: GenericImageSettings | null | undefined;
  className?: string;
  emptyLabel?: string;
  fontScale?: number;
}

export const GenericImagePreview = ({
  settings,
  className,
  emptyLabel,
  fontScale = 1,
}: GenericImagePreviewProps) => {
  const hasText = !!settings?.text?.trim();
  const safeScale = Number.isFinite(fontScale) ? Math.max(0.3, Math.min(1, fontScale)) : 1;
  const computedFontSize = Math.max(10, (settings?.fontSize ?? 16) * safeScale);
  const computedPadding = Math.max(4, 16 * safeScale);

  return (
    <div
      className={cn(
        "flex items-center justify-center w-full h-full",
        className,
      )}
      style={{
        backgroundColor: settings?.backgroundColor ?? "#FFFFFF",
        padding: `${computedPadding}px`,
      }}
    >
      {hasText && settings ? (
        <p
          style={{
            fontFamily: settings.fontFamily ?? "Arial",
            fontSize: `${computedFontSize}px`,
            color: settings.fontColor ?? "#000000",
            width: "100%",
            textAlign: settings.alignment ?? "center",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            margin: 0,
          }}
        >
          {settings.text}
        </p>
      ) : (
        <p className="text-slate-500 text-sm">{emptyLabel ?? ""}</p>
      )}
    </div>
  );
};

export const hasGenericImageConfigured = (
  settings: GenericImageSettings | null | undefined,
): boolean => !!settings?.text?.trim();
